import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IDatasourceCredentialsClickhouse} from '@/api/types/datasource/credentials/clickhouse';

const fieldNames: TAPIElementFieldNames<IDatasourceCredentialsClickhouse> = {
  pageTitle: 'Источники данных (clickhouse)',
  drawerTitle: 'Источник данных (clickhouse)',

  url: 'Ссылка',
  database: 'База данных',
  user: 'Пользователь',
  password: 'Пароль',
};

const useDatasourceClickhouseControllerHook = () => {
  const validate = (form?: IDatasourceCredentialsClickhouse) => {
    return !!form?.url && !!form.database && !!form.user && !!form.password;
  };

  return {
    fieldNames,

    validate,
  };
};

export const datasourceClickhouseController =
  useDatasourceClickhouseControllerHook();
